import {
  SettingsStorageService,
  StorageSettingsInfo
} from '../services/settings-storage.service';
import useService from '../../injector/hooks/useService';

export default function useSettingsStorageService() {
  const settingsStorageService = useService(SettingsStorageService);

  return {
    getSettings: (key: string, storageSettingsInfo?: StorageSettingsInfo) =>
      settingsStorageService.getSettings(key, storageSettingsInfo),
    applySettings: (key: string, value: any, storageSettingsInfo?: StorageSettingsInfo) =>
      settingsStorageService.applySettings(key, value, storageSettingsInfo)
  };
}
